"use strict";

var _defineProperty = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _Object$freeze;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var countries_1 = require("./countries"); // Está armado así para que pueda importarse la constante y verificar que exista


exports.SiteIds = Object.freeze({
  BMAR: 'BMAR',
  BMEC: 'BMEC',
  BMPE: 'BMPE',
  BMVE: 'BMVE',
  BMMX: 'BMMX',
  BMPA: 'BMPA',
  BMCL: 'BMCL',
  ZJAR: 'ZJAR'
});
exports.SiteConfig = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, exports.SiteIds.BMAR, {
  nombre: 'Bumeran',
  pais: countries_1.Countries.AR,
  lng: 'es-AR',
  dominio: 'https://www.bumeran.com.ar'
}), _defineProperty(_Object$freeze, exports.SiteIds.BMCL, {
  nombre: 'Laborum',
  pais: countries_1.Countries.CL,
  lng: 'es-CL',
  dominio: 'https://www.laborum.cl'
}), _defineProperty(_Object$freeze, exports.SiteIds.BMEC, {
  nombre: 'Multitrabajos',
  pais: countries_1.Countries.EC,
  lng: 'es-EC',
  dominio: 'https://www.multitrabajos.com'
}), _defineProperty(_Object$freeze, exports.SiteIds.BMMX, {
  nombre: 'Bumeran',
  pais: countries_1.Countries.MX,
  lng: 'es-MX',
  dominio: 'https://www.bumeran.com.mx'
}), _defineProperty(_Object$freeze, exports.SiteIds.BMPA, {
  nombre: 'Konzerta',
  pais: countries_1.Countries.PA,
  lng: 'es-PA',
  dominio: 'https://www.konzerta.com'
}), _defineProperty(_Object$freeze, exports.SiteIds.BMPE, {
  nombre: 'Bumeran',
  pais: countries_1.Countries.PE,
  lng: 'es-PE',
  dominio: 'https://www.bumeran.com.pe'
}), _defineProperty(_Object$freeze, exports.SiteIds.BMVE, {
  nombre: 'Bumeran',
  pais: countries_1.Countries.VE,
  lng: 'es-VE',
  dominio: 'https://www.bumeran.com.ve'
}), _defineProperty(_Object$freeze, exports.SiteIds.ZJAR, {
  nombre: 'ZonaJobs',
  pais: countries_1.Countries.AR,
  lng: 'es-ZJAR',
  dominio: 'https://www.zonajobs.com.ar'
}), _Object$freeze));